module.exports = __webpack_public_path__ + "img/newlogo7.0b6da18c.png";